// extracted by mini-css-extract-plugin
export default {"primaryColor":"#f68b28","primaryColorWithAlpha":"rgba(246,139,40,.1019607843)","mainBgColor":"#1f2025","secondBgColor":"#26262e"};